import { Component, EventEmitter, OnInit, Input, Output, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DataService } from '../../../core/data/data-service';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { PriceContentService } from '../../../core/routing/services/asset-library/price-content.service';
import { CreatePriceContentResponse, PriceContentConfiguration, PriceContent, PriceContentViewModel } from '../price-content/interfaces/price-content.i';
import moment from 'moment';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';
import { Router } from '@angular/router';
import { ProfileRequest, PriceContent as PriceContents } from '../../create-profile/interface/profile.i';
import { CommonService } from '../../../common/services/common.service';
import { Utils } from '../../../common/utils/utils';
import { FormFactor } from '../form-factors/interfaces/form-factors.i';

@Component({
  selector: 'iposcen-create-price-content',
  templateUrl: './create-price-content.component.html',
  styleUrls: ['./create-price-content.component.scss']
})
export class CreatePriceContentComponent implements OnInit, OnDestroy {
  @Input() isNavigated: boolean;
  @Input() presentpage;
  @Output() readonly goBacktoPriceContent = new EventEmitter<object>();
  @ViewChild('formFactorsModal') formFactorsModal: ElementRef;
  priceContentgrpForm: FormGroup;
  isPublishedDateInCorrect: boolean;
  isExpiredDateIncorrect: boolean;
  isSubmitted: boolean;
  isFormValid: boolean;
  isEdit: boolean;
  selectedPriceContentId: string;
  selectedPriceContent: PriceContentViewModel;
  publishDateValue: string;
  dateTimeValue: string;
  expiryDateTime: string;
  customPublishDateResult: string;
  customExpiryDateResult: string;
  ispublishDateNowStatus: boolean;
  editPublishDateInfo: string;
  editexpiryDateInfo: string;
  isPublishExpiryNever: boolean;
  isPublishDateCustomDatepicker: boolean;
  isExpiryDatePicker: boolean;
  currentDetailPage: string;
  createdPriceContentId: string;
  priceCId: string;
  profileData: string;
  isCustomPublishDateCorrect: boolean;
  isCustomExpiryDateCorrect: boolean;
  priceContentGroupData: PriceContentConfiguration;
  updatedSelectedPriceContent: PriceContentViewModel;
  publishednamePlaceHolderText = AssetLibraryConstants.PUBLISHED_NAME_PLACEHOLDER;
  internalnamePlaceHolderText = AssetLibraryConstants.INTERNAL_NAME_PLACEHOLDER;
  //IIT2-4654
  selectedFormFactors: FormFactor;
  defaultFormFactors: FormFactor = {
    allDevices: true,
    devices: GlobalConstants.ALL,
    manufacturer: GlobalConstants.ALL,
    processors: GlobalConstants.ALL,
    generations: GlobalConstants.ALL
  };
  deviceTypes = GlobalConstants.DEVICE_TYPES;
  manufacturers = GlobalConstants.MANUFACTURERS;
  processors = GlobalConstants.PROCESSORS;
  generation = GlobalConstants.GENERATIONS;
  //IIT2-4654 end
  isRussian = localStorage.getItem('preferredLanguage') === 'ru';
  isCustomPublishTimeZoneSelected = false;
  isCustomExpiryTimeZoneSelected = false;
  private ngUnsubscribe = new Subject<boolean>();
  
  constructor(
    private formBuilder: FormBuilder,
    private priceContentService: PriceContentService,
    private dataService: DataService,
    private router: Router,
    private createProfileService: CreateProfileService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.dateTimeValue = '';
    this.expiryDateTime = '';
    this.isExpiredDateIncorrect = false;
    this.isCustomPublishDateCorrect = false;
    this.isCustomExpiryDateCorrect = false;
    this.customPublishDateResult = GlobalConstants.NOW;
    this.customExpiryDateResult = GlobalConstants.NEVER;
    this.dataService.getPriceContent()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((priceContentToEdit: any) => {
        if (priceContentToEdit) {
          this.updatedSelectedPriceContent = priceContentToEdit as unknown as PriceContentViewModel;
          this.priceContentService.buttonName = GlobalConstants.SAVE_CHANGES;
          this.isEdit = true;
          this.selectedPriceContent = priceContentToEdit;
          this.selectedPriceContentId = priceContentToEdit.id;
          if (priceContentToEdit.configurations.isPublishDateNow) {
            this.isPublishDateCustomDatepicker = false;
            this.editPublishDateInfo = GlobalConstants.NOW;
          } else {
            this.isPublishDateCustomDatepicker = true;
            this.customPublishDateResult = priceContentToEdit.configurations.publishTime;
            this.editPublishDateInfo = priceContentToEdit.configurations.publishTime;
          }
          if (priceContentToEdit.configurations.isPublishExpiryNever) {
            this.isExpiryDatePicker = false;
            this.editexpiryDateInfo = GlobalConstants.NEVER;
          } else {
            this.isExpiryDatePicker = true;
            this.customExpiryDateResult = priceContentToEdit.configurations.expireTime;
            this.editexpiryDateInfo = priceContentToEdit.configurations.expireTime;
          }
          this.selectedFormFactors = priceContentToEdit.configurations?.formFactor ? priceContentToEdit.configurations?.formFactor : this.defaultFormFactors;//IIT2-4654
          //Above code is to handle old content groups which might have empty formfactorValue. 
        } else {
          this.priceContentService.buttonName = GlobalConstants.SAVE_AND_PROCEED;
          this.selectedFormFactors = this.defaultFormFactors;//IIT2-4654
        }
      });
    this.isSubmitted = false;
    this.createPriceContentGroupFrom();
    //To get original contengrouppages for normal edit flow
    if(this.selectedPriceContent){
      this.priceContentService.getPriceContentById(this.selectedPriceContentId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(getPriceContentById => {       
        this.priceContentGroupData = JSON.parse(getPriceContentById.priceContent.configurations) as PriceContentConfiguration;
        },
          error => {
              // do something
          });
    }
    this.commonService.getRetailGifValue
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(data => {
      if (data === true) {
        this.commonService.setSwitchstatus(true);
      }
    });
    this.commonService.setPresentPageValue(this.presentpage);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  createPriceContentGroupFrom() {
    this.priceContentgrpForm = this.formBuilder.group({
      publishedName: new FormControl((this.selectedPriceContent) ? this.selectedPriceContent.configurations.publishedName : '',
        [Validators.required, Validators.maxLength(50)]),
      publishedTimeStamp: new FormControl((this.selectedPriceContent) ? this.selectedPriceContent.configurations.publishTime : GlobalConstants.NOW),
      internalName: new FormControl((this.selectedPriceContent) ? this.selectedPriceContent.configurations.internalName : ''),
      expiryTimeStamp: new FormControl((this.selectedPriceContent) ? this.selectedPriceContent.configurations.expireTime : GlobalConstants.NEVER)
    });
  }

  //Datetimepicker popover
  getPublishDate(selectedDate) {
    this.dateTimeValue = `${selectedDate[0]}, ${selectedDate[1]}`;
  }

  getExpiryNever(time) {
    this.expiryDateTime = GlobalConstants.NEVER;
  }

  getPublishSelectedTime(time) {
    this.dateTimeValue = time;
  }

  getExpirySelectedTime(selectedDate) {
    let expiryDateSmaller = false;
    const expiryDateVal = selectedDate[0];
    if (this.dateTimeValue.toString() === '') {
      // check if expiry date is smaller than current date
      const today = Utils.getCurrentDate();
      expiryDateSmaller = Date.parse(expiryDateVal) <
        Date.parse(today);
    } else {
      const publishDateValue = this.dateTimeValue[0];
      expiryDateSmaller = Date.parse(expiryDateVal) <
        Date.parse(publishDateValue);
    }
    this.expiryDateTime = `${selectedDate[0]}, ${selectedDate[1]}`;
  }

  // check if published date is smaller than today's date
  checkPublishedDateTime() {
    this.isSubmitted = false;
    const today = new Date();
    let isPublishedDateSmaller: boolean;
    if (this.priceContentgrpForm.controls.publishedTimeStamp.toString() !== '') {
      isPublishedDateSmaller = new Date(this.priceContentgrpForm.controls.publishedTimeStamp.value).getTime() < new Date().getTime();
    }

    this.isPublishedDateInCorrect = isPublishedDateSmaller;
  }

  customValidation() {
    if (this.isPublishDateCustomDatepicker) {
      this.isCustomPublishDateCorrect = (this.customPublishDateResult === GlobalConstants.NOW);
    }
    if (this.isExpiryDatePicker) {
      this.isCustomExpiryDateCorrect = (this.customExpiryDateResult === GlobalConstants.NEVER);
    }
  }

  // check if expiry date is smaller than published date
  checkExpiryDateTime() {
    if (this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = Utils.customDateCheck(this.customPublishDateResult, this.customExpiryDateResult);
    }
  }

  updatePriceContent() {
    const priceContent = this.selectedPriceContent as unknown as PriceContent;
    const priceFormFactor: FormFactor = Utils.getFormFactorValues(this.selectedFormFactors);//IIT2-4654
    const priceContantConfig: PriceContentConfiguration = {
      publishedName: this.priceContentgrpForm.controls.publishedName.value.trim(),
      internalName: this.priceContentgrpForm.controls.internalName.value,
      publishTime: (this.customPublishDateResult.toString() !== GlobalConstants.NOW) ?
        this.customPublishDateResult.toString() : Utils.getCurrentDate(),
      expireTime: (this.customExpiryDateResult.toString() !== GlobalConstants.NEVER) ?
        this.customExpiryDateResult.toString() : GlobalConstants.NEVER,
      contentScheduleTimezoneCode: 'CST',
      formFactor: priceFormFactor,
      type: GlobalConstants.PRICE_CONTENT_GROUP,
      contentGroupPages: this.priceContentGroupData.contentGroupPages,
      isPublishDateNow: !this.isPublishDateCustomDatepicker,
      isPublishExpiryNever: !this.isExpiryDatePicker
    };
    if(priceContantConfig.expireTime !== GlobalConstants.NEVER ){
      priceContantConfig.expireTime = Utils.changeSaveDateFormat(priceContantConfig.expireTime);
    }
    if(!priceContantConfig.isPublishDateNow){
      priceContantConfig.publishTime = Utils.changeSaveDateFormat(priceContantConfig.publishTime);
    }
    const priceContentConfigObj: PriceContentConfiguration = this.updatedSelectedPriceContent.configurations as PriceContentConfiguration;
    priceContent.configurations = JSON.stringify(priceContantConfig);
    this.priceContentService.putPriceContentById(JSON.stringify(priceContent), this.selectedPriceContentId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(putPriceContentResponse => {
        if(this.isNavigated){  
          const priceContentResponseObj = {priceContent: putPriceContentResponse.priceContent};  
          priceContentResponseObj.priceContent.configurations =
            JSON.parse(priceContentResponseObj.priceContent.configurations) as PriceContentConfiguration;         
            priceContentResponseObj.priceContent.configurations.contentGroupPages = priceContentConfigObj.contentGroupPages;                 
            this.goBacktoPriceContent.emit(priceContentResponseObj);
        }else{
          const putPriceContentResponseObj: CreatePriceContentResponse = putPriceContentResponse as CreatePriceContentResponse;
          this.goBacktoPriceContent.emit(putPriceContentResponseObj);
        }        
      },
        error => {
        });
  }

  createNewPriceContent() {
    const priceFormFactor: FormFactor = Utils.getFormFactorValues(this.selectedFormFactors);//IIT2-4654
    const priceContent: PriceContentConfiguration = {
      publishedName: this.priceContentgrpForm.controls.publishedName.value.trim(),
      internalName: this.priceContentgrpForm.controls.internalName.value,
      publishTime: (this.customPublishDateResult.toString() !== GlobalConstants.NOW) ?
        this.customPublishDateResult.toString() : Utils.getCurrentDate(),
      expireTime: (this.customExpiryDateResult.toString() !== GlobalConstants.NEVER) ?
        this.customExpiryDateResult.toString() : GlobalConstants.NEVER,
      contentScheduleTimezoneCode: 'CST',
      formFactor: priceFormFactor,
      type: GlobalConstants.PRICE_CONTENT_GROUP,
      contentGroupPages: [],
      isPublishDateNow: !this.isPublishDateCustomDatepicker,
      isPublishExpiryNever: !this.isExpiryDatePicker
    };
    if(priceContent.expireTime !== GlobalConstants.NEVER ){
      priceContent.expireTime = Utils.changeSaveDateFormat(priceContent.expireTime);
    }
    if(!priceContent.isPublishDateNow){
      priceContent.publishTime = Utils.changeSaveDateFormat(priceContent.publishTime);
    }
    this.priceContentService.createPriceContent(JSON.stringify(priceContent))
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(createPriceContentResponse => {
        const createPriceContentResponseObj: CreatePriceContentResponse = createPriceContentResponse as CreatePriceContentResponse;
        // Coding for create profile logo conten
        this.currentDetailPage = this.router.url;
        const pageName = this.currentDetailPage.lastIndexOf('/');
        // checking if Current URL is for create profile
        if (this.currentDetailPage.substring(pageName + 1) === GlobalConstants.CREATE_PROFILE) {
          this.priceCId = createPriceContentResponse.priceContent.id;
          this.profileData = this.createProfileService.getProfileId();
          const PriceContentInfo: PriceContents = {
            priceContentId: this.priceCId,
            showOnDevice: true
          };
          const profileRequest: ProfileRequest = {
            priceContents: [PriceContentInfo]
          };
          this.createProfileService.updateProfile(this.profileData, JSON.stringify(profileRequest))
            .pipe(takeUntil(this.ngUnsubscribe))
            .pipe(first())
            .subscribe(Response => {
              this.goBacktoPriceContent.emit(createPriceContentResponseObj);
            },
              error => {
              });
        } else {
          this.goBacktoPriceContent.emit(createPriceContentResponseObj);
        }
      },
        error => {
        });
  }

  cancel() {
    this.isSubmitted = false;
    this.goBacktoPriceContent.emit({ cancel: true });
    this.dataService.setPriceContent(undefined);
  }

  onAdd() {
    this.isSubmitted = true;
    this.checkExpiryDateTime();
    this.customValidation();
    this.isFormValid = !this.isPublishedDateInCorrect && !this.isExpiredDateIncorrect &&
      !this.isCustomExpiryDateCorrect &&
      !this.isCustomPublishDateCorrect &&
      this.priceContentgrpForm?.controls?.publishedName?.value.trim() !== ''
      && !this.priceContentgrpForm?.controls?.publishedName?.errors?.maxlength &&
      !this.isCustomPublishTimeZoneSelected && !this.isCustomExpiryTimeZoneSelected;
    if (this.isFormValid) {
      if (this.selectedPriceContentId) { // Since price content id exists, it is an update process
        this.updatePriceContent();
      } else {
        this.createNewPriceContent();
      }
      
    }
  }

  selectCustomPublishDate(datetimeOption) {
    this.isPublishDateCustomDatepicker = this.checkStatus(datetimeOption);
    if (!this.isPublishDateCustomDatepicker && this.customPublishDateResult !== GlobalConstants.NOW) {
      this.customPublishDateResult = Utils.getCurrentDate();
    }
    if (datetimeOption === GlobalConstants.NOW) {
      this.isCustomPublishDateCorrect = false;
      this.isCustomPublishTimeZoneSelected = false;
    }
  }

  selectExpiryDateTimeZone(datetimeOption) {
    this.isExpiryDatePicker = this.checkStatus(datetimeOption);
    if(this.isExpiryDatePicker && this.editexpiryDateInfo) {
      this.customExpiryDateResult = this.editexpiryDateInfo;
    }
    if (!this.isExpiryDatePicker && this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.customExpiryDateResult = GlobalConstants.NEVER;
    }
    if (datetimeOption === GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = false;
      this.isCustomExpiryDateCorrect = false;
      this.isCustomExpiryTimeZoneSelected = false;
    }
  }

  checkStatus(status) {
    return (status === GlobalConstants.CUSTOM);
  }

  getLogoContentPublishDate(data) {
    this.customPublishDateResult = this.generateDateTimeZone(data);
  }

  getLogoContentExpiryDate(data) {
    this.customExpiryDateResult = this.generateDateTimeZone(data);
  }

  generateDateTimeZone(data) {
    return `${moment(data.dateVal).format(GlobalConstants.DATE_FORMAT)} ${data.hour}:${data.min} ${data.timeZone}`;
  }
  checkIfTimeset(data,check){
    if(check==='publish'){
      if(data[0] && data[1]){
        this.isCustomPublishDateCorrect = false;
      }
    }else{
      if(data[0] && data[1]){
        this.isCustomExpiryDateCorrect = false;
      }
    }
  }
  //IIT2-4654
  openModal(modal: any) {
    modal.open();
  }

  closeModal(modal: any) {
    modal.close();
  }

  openFormFactorsModal() {
    this.openModal(this.formFactorsModal);
  }
  applyFormFactor(updatedFormFactors) {
    this.selectedFormFactors = updatedFormFactors;
    this.closeModal(this.formFactorsModal);
  }
  //IIT2-4654 end

  checkTimeZone(data, check) {
    (check === GlobalConstants.PUBLISH) ? (this.isCustomPublishTimeZoneSelected = !data) : (this.isCustomExpiryTimeZoneSelected = !data);
  }
}
